<template>
  <div>
    <v-card height="428px" flat>
      <div class="mt-n1" style="overflow-y: auto; overflow-x: hidden; max-height: 374px">
        <div id="fs-html-pedido"></div>
      <v-row>
        <v-col>
          Contato: {{ itemMostrarDetalhes.contato }}<br/>
          Nome: {{ itemMostrarDetalhes.nome }}<br/>
          CNPJ: {{ itemMostrarDetalhes.cnpj }}<br/>
          Telefone: {{ itemMostrarDetalhes.telefone }} - {{ itemMostrarDetalhes.whatsapp }}<br/>
          E-mail: {{ itemMostrarDetalhes.email }}
        </v-col>
        <v-col>
          Endereço: {{ itemMostrarDetalhes.endereco_cep }}<br/>
          Endereço: {{ itemMostrarDetalhes.endereco_logradouro }}
          Número: {{ itemMostrarDetalhes.endereco_numero }}
          {{ itemMostrarDetalhes.endereco_complemento }}<br/>
          Bairro: {{ itemMostrarDetalhes.endereco_bairro }} <br/>
          Cidade: {{ itemMostrarDetalhes.endereco_cidade }} - {{ itemMostrarDetalhes.endereco_uf }}
        </v-col>
      </v-row>
      </div>

      <v-card-actions class="mb-n1" style="padding: 0px; position: absolute; bottom: 0; right: 0">
        <v-btn color="#2A2F50" @click="visualizarPDF" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-file-pdf</v-icon>
          Visualizar PDF
        </v-btn>
        <v-btn color="#2A2F50" @click="baixarPDF" class="mr-2" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>
          Baixar PDF
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="#2A2F50" :href="urlImpressao" target="_blank" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-printer</v-icon>
          Imprimir
        </v-btn>
        <v-btn color="warning" @click="fecharDialog()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { get } from '@/api/crud'
require('dotenv').config()

export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDialog: Function
  },
  data () {
    return {
      urlImpressao: `${process.env.VUE_APP_BASE_URL}/site/orcamentoimprimir/${this.itemMostrarDetalhes.hash}`
    }
  },
  mounted () {
    this.loadPedido()
  },
  methods: {
    baixarPDF () {
      window.open(process.env.VUE_APP_BASE_URL + '/PDF/baixarPDFs/' + this.itemMostrarDetalhes.hash + '/Pedido-Fortkol-' + this.itemMostrarDetalhes.id + '.pdf', '_blank')
    },

    visualizarPDF () {
      window.open(process.env.VUE_APP_BASE_URL + '/PDF/visualizarPDFs/' + this.itemMostrarDetalhes.hash + '/Pedido-Fortkol-' + this.itemMostrarDetalhes.id + '.pdf', '_blank')
      // await configAPI.visualizarPDF(this.hash, 'Pedido-Fortkol-' + this.getCarrinho.id + '.pdf')
    },
    async loadPedido () {
      const data = await get('/site/orcamentoimprimircrm', {}, this.itemMostrarDetalhes.id)
      document.getElementById('fs-html-pedido').innerHTML = data
    }
  }
}
</script>

<style scoped>
th {
  color: white !important;
}
</style>
